<template>
  <div class="operatingsystem-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('operatingsystem_edit')"/>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-microsoft-windows</v-icon>{{$t('profile.operatingsystem.operatingsystems')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <OperatingSystemFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
@click:row="showHandler"
@contextmenu:row="showHandlerExt"
          >

            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandler(props.item)"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import OperatingSystemFilterForm from '../../components/operatingsystem/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'OperatingSystemList',
  servicePrefix: 'OperatingSystem',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
    ActionCell,
    OperatingSystemFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('profile.operatingsystem.name'), value: 'name' },
        { text: this.$t('global.archive'), value: 'archive'},
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      selected: [],
footer: {
  'itemsPerPageText': "",
},
      options: {sortBy : ['name'], sortDesc : [false]}
    };
  },
  computed: {
    ...mapGetters('operatingsystem', {
      items: 'list'
    }),
    ...mapFields('operatingsystem', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('operatingsystem', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
